/* cart-upsell.js — adds the "Complete your routine" cross-sell to the cart on the
   matched subscription cadence, then refreshes the drawer in place.

   A single delegated listener on document survives the drawer's innerHTML swaps
   (assets/cart-drawer.js replaces #CartDrawer / .drawer__inner on every cart change),
   so it keeps working after each re-render without re-binding. */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  /* The drawer owns the list of sections a cart Ajax call has to ask for (cart-drawer.js:134);
     cart-discount.js and cart-line-edit.js both read it from there rather than keeping their own
     copy, and hardcoding it here is what left the mobile bubble out. The literal fallback is only
     reached from a page with no <cart-drawer> — the PDP suggested-products row. */
  function sectionIds() {
    var drawer = document.querySelector('cart-drawer');
    var ids = drawer && typeof drawer.sectionIdsToRender === 'function' ? drawer.sectionIdsToRender() : [];
    return ids.length ? ids : ['cart-drawer', 'cart-icon-bubble', 'cart-icon-bubble--mobile', 'cart-free-delivery'];
  }

  function applySection(sections, id, selector) {
    if (!sections[id]) return;
    var inner = sectionInner(sections[id], '.shopify-section');
    if (inner == null) return;
    document.querySelectorAll(selector).forEach(function (el) { el.innerHTML = inner; });
  }

  /* Shopify returns the reason an add failed in data.description ("You can only add 2 of this
     item..."); discarding it left the button silently stopping its spinner with nothing said.
     product-form.js:48 surfaces the same field on the PDP. The node lives inside the drawer
     (snippets/cart-drawer.liquid:177) and a successful add replaces it wholesale, so it clears
     itself; callers outside the drawer have nothing to write to and degrade quietly. */
  function showError(description) {
    var node = document.getElementById('CartDrawer-CartErrors');
    if (node) node.textContent = description || (window.cartStrings && window.cartStrings.error) || '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled') || btn.classList.contains('is-loading')) return;

    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    var item = { id: variantId, quantity: 1 };
    if (btn.dataset.sellingPlan) item.selling_plan = parseInt(btn.dataset.sellingPlan, 10);

    btn.classList.add('is-loading');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: sectionIds(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { showError(data.description); btn.classList.remove('is-loading'); return; } // add error
        // Trial rules (assets/cart-rules.js) may take a line out; render the cart they leave.
        return window.WythoutCartRules ? window.WythoutCartRules.afterAdd(data) : data;
      })
      .then(function (data) {
        if (!data) return;

        var sections = data.sections || {};

        // Clear the spinner. Inside the drawer this button is about to be
        // replaced by the innerHTML swap below, so it is a no-op there — it
        // matters for callers outside the drawer (the PDP suggested-products
        // row), whose buttons survive the add and would otherwise spin forever.
        btn.classList.remove('is-loading');

        // Swap the drawer's inner markup (items + upsell + totals all refresh).
        if (sections['cart-drawer']) {
          var newInner = sectionInner(sections['cart-drawer'], '#CartDrawer');
          var curInner = document.querySelector('#CartDrawer');
          if (newInner != null && curInner) {
            curInner.innerHTML = newInner;
            var overlay = document.querySelector('#CartDrawer-Overlay');
            var drawerEl = document.querySelector('cart-drawer');
            if (overlay && drawerEl) overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
          }
        }

        // The cart went from empty to non-empty, so drop is-empty off the
        // <cart-drawer> wrapper. Liquid stamps it at render time
        // (snippets/cart-drawer.liquid:77) and it lives OUTSIDE #CartDrawer, so
        // the innerHTML swap above never clears it — leaving CSS hiding the
        // items in a drawer that actually has them. product-form.js:80 and
        // cart.js:100 do the same thing on their own add paths; this one was
        // only ever reachable from a non-empty cart until the PDP suggested
        // row started calling it.
        var wrapper = document.querySelector('cart-drawer');
        if (wrapper) wrapper.classList.remove('is-empty');

        // Update the header cart-count bubble(s) and the free-delivery bar. The mobile bubble is
        // its own section rendered into #cart-icon-bubble--mobile (sections/header.liquid:413) and
        // is the badge every viewport under 1025px shows: refreshing only #cart-icon-bubble left a
        // shopper closing the drawer onto a header still claiming the cart was empty. Desktop was
        // never affected — its "Cart (N)" mirrors #cart-icon-bubble (header.liquid:745).
        // #cart-free-delivery is absent unless the merchant has that bar on, hence no assumption.
        applySection(sections, 'cart-icon-bubble', '#cart-icon-bubble');
        applySection(sections, 'cart-icon-bubble--mobile', '#cart-icon-bubble--mobile');
        applySection(sections, 'cart-free-delivery', '#cart-free-delivery');
        if (data.cartRulesNote) window.WythoutCartRules.showNote(data.cartRulesNote);

        // Make sure the drawer is open so the shopper sees the added item.
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
          drawer.open();
        }
      })
      .catch(function () { showError(); btn.classList.remove('is-loading'); });
  });
})();
